import styled from 'styled-components';

export const DashboardPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  border-left: 1px solid #e8e8e8;
`;

export const DashboardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
  gap: 12px;
  min-height: 48px;
`;

export const DashboardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const DashboardHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DashboardContent = styled.div`
  flex: 1;
  overflow-y: scroll;
  position: relative;
`;

export const DashboardTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #262626;
`;
